import React from 'react'
import AboutComponent1 from '../components/AboutComponent1';
import Banner from '../components/Banner';
import AboutComponent2 from '../components/AboutComponent2';
import AboutComponent3 from '../components/AboutComponent3';
import AboutComponent4 from '../components/AboutComponent4';
import AboutComponent5 from '../components/AboutComponent5';
import Inquiry from '../components/Inquiry';

const About = () => {
  return (
    <div>
      <AboutComponent1/>
      <Banner />
      <AboutComponent2/>
      <AboutComponent3/>
      <AboutComponent4/>
      <AboutComponent5/>
      <Inquiry/>
    </div>
  )
}

export default About;